"use strict";

export class Getting_started {
  constructor() {
    $(".auto-height").matchHeight();
  }
}
